// extracted by mini-css-extract-plugin
export default {"container":"user_container__sOXiH","userContent":"user_userContent__kRGbz"};